/**
 * Customizations related to the Lottie Player plugin.
 *
 * Compatibilizes Lottie animations with the reveal effect on clicking Accordion
 * Items.
 *
 * @link https://docs.lottiefiles.com/dotlottie-players/components/player-component
 * @link https://airbnb.io/lottie/#/web?id=usage-1
 */

const lottiePlayer = () => {
  const notReadyStates = ['destroyed', 'error', 'loading'];

  let lottieElements = [];
  let lottieElementsFound = false;

  let accordionItems = [];
  let accordionItemsFound = false;

  /*
   * Patches a bug in the Lottie plugin in which the Divi's module ID and class
   * are added to two different DOM elements.
   */
  const removeExtraAttributes = (lottieElement) => {
    const lottieParent = lottieElement.parentElement;
    lottieParent.removeAttribute('id');
    lottieParent.removeAttribute('class');
  };

  /*
  * Adds an "aria-hidden" attribute to the parent element
  * This is used to ensure the element is hidden from assistive technologies,
  * improving accessibility.
  */
  const addAttributes = (lottieElement) => {
    const lottieParent = lottieElement.parentElement;
    lottieParent.setAttribute('aria-hidden', 'true');
  };

  /*
   * On click Accordion Item, restart related Lottie animations.
   */
  const isReady = (lottieElement) => {
    const stateIsSet = 'currentState' in lottieElement;
    const stateIsReady = stateIsSet && notReadyStates.indexOf(lottieElement.currentState) === -1;
    return stateIsReady;
  };

  const areRelated = (lottieElement, accordionItem) => {
    const { relatedBlock } = accordionItem;
    const inRelatedBlock = relatedBlock && relatedBlock.contains(lottieElement);
    const inAccordionItem = accordionItem.contains(lottieElement);
    return inRelatedBlock || inAccordionItem;
  };

  const restartAnimationsRelatedTo = (accordionItem) => {
    lottieElements.forEach((lottieElement) => {
      if (isReady(lottieElement) && areRelated(lottieElement, accordionItem)) {
        lottieElement.seek('0%');
      }
    });
  };

  const onOpenAccordionItem = (event) => {
    const accordionItem = event.target;
    accordionItem.relatedBlock = event.detail.relatedBlock;
    restartAnimationsRelatedTo(accordionItem);
  };

  const init = () => {
    lottieElements = Array.from(document.getElementsByTagName('dotlottie-player'));
    lottieElementsFound = lottieElements.length > 0;
    accordionItems = Array.from(document.getElementsByClassName('qusd-accordion-item'));
    accordionItemsFound = accordionItems.length > 0;

    if (lottieElementsFound) {
      lottieElements.forEach((lottieElement) => {
        addAttributes(lottieElement);
      });
    }

    if (lottieElementsFound && accordionItemsFound) {
      lottieElements.forEach((lottieElement) => {
        removeExtraAttributes(lottieElement);
      });
      accordionItems.forEach((accordionItem) => {
        accordionItem.addEventListener('rocket:AccordionItem:beforeOpen', onOpenAccordionItem);
      });
    }
  };

  return {
    init,
  };
};

export default lottiePlayer();
